import { cx } from '@linaria/core';
import { forwardRef } from 'react';
import { useNavigationManager } from '@provider/navigation';
import { ShowFor, Chevron, HideFor } from '@utils/react';
import { MobileSearch } from '../../../atoms/search.mobile.js';
import { userAreaBreakpoints } from '../../../const.breakpoints.js';
import { headerCls, headingCls } from '../../../layout/content.style.js';
import { Filters } from '../molecules/filters/filters.js';
import { componentEntryStore } from '../state.js';
import { StudentTablist } from './molecule.tablist.js';
import { header, mobileActions, filters } from './root.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { MobileFilters } from '../molecules/filters/filters.mobile.js';

const StudentEntriesView = /*#__PURE__*/forwardRef(function StudentEntriesView(props, ref) {
  const navigation = useNavigationManager();
  return /*#__PURE__*/jsxs("section", {
    ref: ref,
    children: [/*#__PURE__*/jsxs("header", {
      className: cx(headerCls, header),
      children: [/*#__PURE__*/jsxs("h1", {
        className: headingCls,
        children: [/*#__PURE__*/jsx(ShowFor, {
          breakpoint: userAreaBreakpoints.mobile,
          children: /*#__PURE__*/jsxs("button", {
            "aria-label": "G\xE5 tilbage oversigt",
            onClick: () => navigation.push("/"),
            children: [/*#__PURE__*/jsx(Chevron, {
              inversed: true,
              size: 12
            }), "Besvarelser"]
          })
        }), /*#__PURE__*/jsx(HideFor, {
          breakpoint: userAreaBreakpoints.mobile,
          children: "Besvarelser"
        })]
      }), /*#__PURE__*/jsxs(ShowFor, {
        className: mobileActions,
        breakpoint: userAreaBreakpoints.mobile,
        children: [/*#__PURE__*/jsx(MobileSearch, {
          label: "S\xF8g i besvarelser",
          onQueryChange: newQuery => componentEntryStore.dispatch(componentEntryStore.actions.setQuery(newQuery))
        }), /*#__PURE__*/jsx(MobileFilters, {
          withTimespan: true,
          withProducts: true
        })]
      })]
    }), /*#__PURE__*/jsx(HideFor, {
      breakpoint: userAreaBreakpoints.mobile,
      children: /*#__PURE__*/jsx(Filters, {
        className: filters,
        withTimespan: true,
        withProducts: true
      })
    }), /*#__PURE__*/jsx(StudentTablist, {})]
  });
});

export { StudentEntriesView };
//# sourceMappingURL=root.js.map
